import { Link } from "react-router-dom"
import {
  BriefcaseIcon,
  BuildingOffice2Icon,
  EnvelopeIcon,
  FolderOpenIcon,
  NewspaperIcon,
} from "@heroicons/react/24/outline"
import { SmallParagraph, SmallText } from "../../components/typography/Typography"
import { ANALYTICS_EVENTS, track } from "../../lib/analytics"

type CompanyItem = {
  href: string
  label: string
  subLabel: string
  icon: typeof BriefcaseIcon
}

const items: CompanyItem[] = [
  {
    href: "/resource-centre",
    label: "Resource Centre",
    subLabel: "Case studies, guides, and press in one place",
    icon: FolderOpenIcon,
  },
  {
    href: "/",
    label: "About Us",
    subLabel: "Who we are and how we manufacture in India",
    icon: BuildingOffice2Icon,
  },
  {
    href: "/in-the-news",
    label: "In the News",
    subLabel: "Press coverage across Indian publications",
    icon: NewspaperIcon,
  },
  {
    href: "/careers",
    label: "Careers",
    subLabel: "Open roles in design, manufacturing, and installation",
    icon: BriefcaseIcon,
  },
  {
    href: "/contact",
    label: "Contact Us",
    subLabel: "Talk to our team about your project",
    icon: EnvelopeIcon,
  },
]

export const CompanyPanel = ({ onClick }: { onClick: () => void }) => {
  const handleClick = (label: string, href: string) => {
    track(ANALYTICS_EVENTS.NAV_LINK_CLICKED, { label, href, surface: "company_panel" })
    onClick()
  }

  return (
    <div className="md:flex md:flex-col lg:grid lg:grid-cols-2 gap-2 p-4">
      {items.map(({ href, label, subLabel, icon: Icon }) => (
        <Link
          key={href}
          to={href}
          onClick={() => handleClick(label, href)}
          className="flex items-center gap-3 rounded-lg border border-gray-200 bg-white p-3 transition hover:bg-gray-50"
        >
          <div className="flex size-10 shrink-0 items-center justify-center rounded bg-gray-100">
            <Icon className="size-5 text-my-orange" aria-hidden="true" />
          </div>
          <div className="flex flex-col gap-1">
            <SmallParagraph>{label}</SmallParagraph>
            <SmallText className="normal-case">{subLabel}</SmallText>
          </div>
        </Link>
      ))}
    </div>
  )
}
